/** @jsx jsx */
/** @jsxFrag React.Fragment */
// @ts-check
import React from 'react';
import { jsx } from 'theme-ui';
import BaseFeatures from '@bottlebooks/gatsby-theme-event/src/components/ProductCard/ProductCardFeatures';

export * from '@bottlebooks/gatsby-theme-event/src/components/ProductCard/ProductCardFeatures';

export default function ProductCardFeatures({ product, ...rest }) {
  return <BaseFeatures product={product} {...rest} />;
}
